/**
 * Mode hemat data (spec CP12): foto tidak dimuat otomatis, tile lebih ringan.
 *
 * Aktif bila perangkat menandai permintaan hemat data
 * (`navigator.connection.saveData` — header `Save-Data` yang dikirim browser)
 * ATAU pengguna menyalakan tombol "Hemat data" (persist lokal, key
 * `smh.data-saver`). Tidak ada deteksi otomatis lain — keadaan disimpan jujur
 * dan dinyatakan lewat `aria-pressed` di Header.
 */

export const DATA_SAVER_STORAGE_KEY = 'smh.data-saver';

interface ConnectionWithSaveData {
  readonly saveData?: boolean;
}

function storage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    // localStorage bisa tertutup (mode privat/kebijakan): hemat data hanya
    // mengikuti `saveData` perangkat, tanpa error ke pengguna.
    return null;
  }
}

function connection(): ConnectionWithSaveData | null {
  const bag = (globalThis as { navigator?: { connection?: ConnectionWithSaveData } }).navigator;
  return bag?.connection ?? null;
}

/** Preferensi manual pengguna: true (nyala), false (mati), null (ikut perangkat). */
export function dataSaverPreference(): boolean | null {
  const value = storage()?.getItem(DATA_SAVER_STORAGE_KEY);
  if (value === '1') return true;
  if (value === '0') return false;
  return null;
}

/** Perangkat menandai hemat data (header `Save-Data` di perangkat ini)? */
export function deviceRequestsDataSaver(): boolean {
  return connection()?.saveData === true;
}

/** Mode hemat data aktif: preferensi pengguna menang, bila kosong ikut perangkat. */
export function dataSaverActive(): boolean {
  const preference = dataSaverPreference();
  if (preference !== null) return preference;
  return deviceRequestsDataSaver();
}

function notifySubscribers(): void {
  const event = new CustomEvent(DATA_SAVER_CHANGE_EVENT);
  globalThis.dispatchEvent(event);
}

export const DATA_SAVER_CHANGE_EVENT = 'smh:data-saver-change';

/** Simpan preferensi manual (null = hapus, kembali mengikuti perangkat). */
export function setDataSaverPreference(value: boolean | null): void {
  const store = storage();
  if (value === null) store?.removeItem(DATA_SAVER_STORAGE_KEY);
  else store?.setItem(DATA_SAVER_STORAGE_KEY, value ? '1' : '0');
  notifySubscribers();
}
